import { isNumber } from 'lodash';
import { QUESTION_OPEN_ENDED, TEXT_LENGTH_LIMIT } from '../../../constants';

export default (question) => {
  const { style, f_name: fName, minLength, maxLength } = question;
  const { promptMissingAnswer, prompt, getText } = Pollfish.ui;

  if (style !== QUESTION_OPEN_ENDED) {
    return true;
  }

  const text = $.trim($('#freeText').val());

  if (
    style === QUESTION_OPEN_ENDED &&
    fName !== 'dg_postal_data' &&
    text.length <= 1
  ) {
    promptMissingAnswer(question);
    return false;
  }

  if (!isNumber(minLength) && !isNumber(maxLength)) {
    return !(text.length > TEXT_LENGTH_LIMIT);
  }

  if (
    isNumber(minLength) &&
    isNumber(maxLength) &&
    (text.length < minLength || text.length > maxLength)
  ) {
    const updatedText = getText('warnings.openEndedMinLimit').replace(
      'XXX',
      minLength,
    );
    prompt(updatedText);
    return false;
  }

  if (isNumber(minLength) && text.length < minLength) {
    const updatedText = getText('warnings.openEndedMinLimit').replace(
      'XXX',
      minLength,
    );
    prompt(updatedText);
    return false;
  }

  if (isNumber(maxLength) && text.length > maxLength) {
    return false;
  }

  return true;
};
